export enum PreprintSubmissionsSort {
  TitleAZ = 'title',
  TitleZA = '-title',
  Oldest = 'date_last_transitioned',
  Newest = '-date_last_transitioned',
}
